import React from 'react';
import {
  getQuoteStageDisplay,
  getWorkshopWorkflowCopy,
  hasInspectionMedia,
  hasCompletionMedia,
  GARAGE_WORKFLOW_STATUSES
} from '../utils/jobTraffic';

/**
 * Garage swimlane / grid card: quote stage, next step, work and technician.
 */
export default function GarageVehicleJobCard({
  veh,
  isActive,
  onClick,
  onKeyDown,
  tags,
  actions,
  /** Extra rows: booked date, price, etc. */
  secondaryMeta
}) {
  const showWorkflow = GARAGE_WORKFLOW_STATUSES.has(veh.status);
  const workflow = showWorkflow ? getWorkshopWorkflowCopy(veh) : null;
  const quoteStage = getQuoteStageDisplay(veh);
  const hasInsp = hasInspectionMedia(veh);
  const hasComp = hasCompletionMedia(veh);
  const preRejected = veh.preWorkSubmissionStatus === 'rejected' && veh.preWorkRejectionNote;

  return (
    <div
      className={`vehicle-card vehicle-card--job-workflow ${isActive ? 'is-active' : ''}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={0}
      role="button"
    >
      <div className="vehicle-card__job-main">
        <div className="vehicle-card__job-row">
          <span className="vehicle-card-reg">{veh.reg}</span>
          {showWorkflow && (
            <span
              className="vehicle-job-quote-pill"
              style={{
                background: `${quoteStage.color}22`,
                color: quoteStage.color
              }}
              title="Where this job is up to"
            >
              {quoteStage.label}
            </span>
          )}
        </div>

        <div className="vehicle-card-title">{veh.vehicle}</div>

        {showWorkflow && workflow && (
          <p className="job-card__next">
            <span className="job-card__kicker">Next step</span>
            {workflow.headline}
          </p>
        )}

        <dl className="job-card__facts">
          {veh.summary ? (
            <>
              <dt>Work</dt>
              <dd>{veh.summary}</dd>
            </>
          ) : null}
          <dt>Technician</dt>
          <dd>{veh.technician || '—'}</dd>
        </dl>
        {secondaryMeta ? <div className="job-card__extra">{secondaryMeta}</div> : null}

        {(hasInsp || hasComp) && (
          <div className="vehicle-job-video-pills" aria-label="Inspection and completion">
            <span className={`vehicle-job-vpill ${hasInsp ? 'vehicle-job-vpill--ok' : 'vehicle-job-vpill--muted'}`}>
              Inspection {hasInsp ? 'done' : 'needed'}
            </span>
            <span className={`vehicle-job-vpill ${hasComp ? 'vehicle-job-vpill--ok' : 'vehicle-job-vpill--muted'}`}>
              Completion {hasComp ? 'done' : 'needed'}
            </span>
          </div>
        )}

        {preRejected && (
          <div className="vehicle-job-manager-note">
            Sent back: {veh.preWorkRejectionNote}
          </div>
        )}

        {tags && tags.length > 0 && <div className="vehicle-card-tags">{tags}</div>}
        {actions}
      </div>
    </div>
  );
}
